import type React from 'react';

interface AmexCardLightIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function AmexCardLightIcon({ size = 24, ...props }: AmexCardLightIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 42 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.62496 0.800049H39.375C40.8241 0.800049 42 1.94527 42 3.35769V27.6437C42 29.0548 40.8241 30.2 39.375 30.2H2.62496C1.17465 30.2002 0 29.0548 0 27.6438V3.35769C0 1.94527 1.17594 0.800049 2.62496 0.800049Z"
        fill="white"
      />
      <path
        d="M6.77251 11.2996L2.62497 20.4776H7.59016L8.2057 19.0142H9.61269L10.2282 20.4776H15.6935V19.3607L16.1805 20.4776H19.0076L19.4946 19.3371V20.4776H30.8609L32.2429 19.0522L33.5371 20.4776L39.375 20.4894L35.2144 15.9142L39.375 11.2996H33.6276L32.2822 12.6986L31.0288 11.2996H18.6638L17.602 13.6685L16.5153 11.2996H11.5605V12.3784L11.0093 11.2996H6.77251ZM7.73325 12.6028H10.1535L12.9046 18.8265V12.6028H15.5559L17.6808 17.0652L19.6391 12.6028H22.2771V19.1887H20.6719L20.6588 14.0281L18.3186 19.1887H16.8827L14.5294 14.0281V19.1887H11.2271L10.6011 17.7122H7.21876L6.59401 19.1874H4.8247L7.73325 12.6028ZM23.7457 12.6028H30.2728L32.2691 14.7592L34.3298 12.6028H36.3261L33.2929 15.9129L36.3261 19.1848H34.2393L32.2429 17.0034L30.1718 19.1848H23.7457V12.6028ZM8.91063 13.7171L7.7963 16.3473H10.0237L8.91063 13.7171ZM25.3576 13.9664V15.1687H28.9184V16.5087H25.3576V17.8212H29.3515L31.2073 15.888L29.4303 13.9653H25.3576V13.9664Z"
        fill="#016FD0"
      />
    </svg>
  );
}
